'use client'

import * as React from 'react'

import PhotoElement from '@/components/elements/PhotoElement'
import type { SanityImage } from '@/constant/types'
import { getSizes } from '@/lib/utils'

type PhotosListPhotoProps = {
  image: SanityImage
  className?: string
}

export default function PhotosListPhoto({
  image,
  className,
}: PhotosListPhotoProps) {
  const { width, height } = image.asset.metadata.dimensions
  const aspectRatio = width / height
  const isPortrait = aspectRatio < 1

  const sizes = getSizes(
    {
      sI: `calc(100vh-48px-48px)`,
      vM: 'calc(100vw-32px-32px-var(--menu-bar-width))',
    },
    'calc(100vw-32px)',
  )

  return (
    <figure data-is-portrait={isPortrait} className={`photo ${className}`}>
      <PhotoElement
        fill
        image={image}
        sizes={sizes}
        className='object-contain'
        style={{
          objectPosition: 'left center',
        }}
      />
    </figure>
  )
}
